var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 10.866 10.866 14 7 14C3.134 14 0 10.866 0 7C0 3.134 3.134 0 7 0C10.866 0 14 3.134 14 7Z",
    fill: "#9B5DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00156 11.0249C7.2915 11.0249 7.52656 10.7898 7.52656 10.4999V6.2999C7.52656 6.00996 7.2915 5.7749 7.00156 5.7749C6.71162 5.7749 6.47656 6.00996 6.47656 6.2999V10.4999C6.47656 10.7898 6.71162 11.0249 7.00156 11.0249Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99687 3.5C7.38348 3.5 7.69687 3.8134 7.69687 4.2C7.69687 4.5866 7.38348 4.9 6.99687 4.9C6.61027 4.9 6.29688 4.5866 6.29688 4.2C6.29688 3.8134 6.61027 3.5 6.99687 3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInfoIcon);
export default __webpack_public_path__ + "static/media/dashboard-info-icon.0ed0f6d86586a8227b27cd7cc23bcac1.svg";
export { ForwardRef as ReactComponent };